import React from 'react';
import ButtonComp from 'atoms/Buttons/Presentation/ButtonComp';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { CLEAR_ALL, CLEAR_SEARCH } from '../MenuPLPConstants/MenuPLPConstants';
import MenuLink from './MenuLink';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const { DarkCloseButton } = IMAGE_PATH;

const NavigationItems = ({
  filterList,
  dietaryList,
  sortByList,
  searchMode,
  isMobile,
  clearSearch,
  handleClearItems,
  menu,
  categories,
  setActiveMenuSelection,
  history,
  hasSubcategory,
  handleSetActive,
  getMenusSubcategory,
  onItemClick,
}) => {
  return [...filterList, ...dietaryList, ...sortByList].length > 0 || searchMode.isSearchedMode ? (
    <div className={isMobile && 'filterListRowMobView'}>
      <ButtonComp
        className={(isMobile && 'clearAllFilterButtonMob') || 'clearAllFilterButton'}
        data-testid='clear-all-handle'
        onClickHandler={(searchMode.isSearchedMode && clearSearch) || handleClearItems}
      >
        {(searchMode.isSearchedMode && translateWithI18Next(CLEAR_SEARCH)) || translateWithI18Next(CLEAR_ALL)}
      </ButtonComp>
      {[...filterList, ...dietaryList, ...sortByList].map(item => (
        <div className=''>
          <div className={isMobile ? 'selectedFilterButtonsMob' : 'selectedFilterButtons'}>
            <span className='textFilteredMob'>{item}</span>
            <img
              className={isMobile ? 'mlcrossMob' : 'mlcross'}
              data-testid={`clear-all-items-${item}`}
              onClick={() => handleClearItems(item)}
              src={DarkCloseButton}
              alt='Close Button'
            />
          </div>
        </div>
      ))}
    </div>
  ) : (
    <MenuLink
      isMobile={isMobile}
      menu={menu}
      categories={categories}
      setActiveMenuSelection={setActiveMenuSelection}
      history={history}
      hasSubcategory={hasSubcategory}
      handleSetActive={handleSetActive}
      getMenusSubcategory={getMenusSubcategory}
      onItemClick={onItemClick}
    />
  );
};

export default React.memo(NavigationItems);
